<template>
  <v-fade-transition>
    <v-overlay
      class="splash-content"
      :model-value="true"
      persistent
      :opacity="0.5"
      scrim="white"
    >
      <v-progress-circular
        class="splash-loader"
        indeterminate
        size="96"
        color="primary"
      />
      <div class="splash-logo-container">
        <img
          alt="logo"
          title="Logo"
          class="splash-logo"
          src="@/assets/logo.svg"
          width="84"
          height="84"
        />
      </div>
    </v-overlay>
  </v-fade-transition>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: 'LoadingOverlay',
})
</script>

<style lang="scss" scoped>
.splash-content {
  :deep(.v-overlay__content) {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .splash-loader,
  .splash-logo-container {
    position: absolute;
    top: 37%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
  }

  .splash-logo-container {
    width: 100px;
    height: 100px;
    padding: 6px;
  }
}

@media (max-width: 400px) {
  .splash-logo-container {
    padding: 15% !important;
  }
  .splash-loader,
  .splash-logo-container {
    top: 33% !important;
  }
}
</style>
